import { CSSProperties, ComponentProps } from 'react';

import Box from '../../Box/Box';

const verticalAlignmentAsFlexboxAlignment = (
    alignment: ComponentProps<typeof Box>['vertical']
): CSSProperties['alignSelf'] => {
    switch (alignment) {
        case 'stretch':
            return 'stretch';
        case 'middle':
            return 'center';
        case 'bottom':
            return 'flex-end';
        case 'top':
            return 'flex-start';
        default:
            return undefined;
    }
};

export default verticalAlignmentAsFlexboxAlignment;
